export default "__VITE_ASSET__NQeo9ZlL__"